import HeroImage6 from "../../assets/icons/hero-illustration-4.png";
import HeroImage5 from "../../assets/icons/truck.png";
// import HeroImage6 from "../../assets/icons/hero-illlustration-6.svg";
import HeroImage2 from "../../assets/icons/slider.png";
import HeroImage3 from "../../assets/icons/hero-illustration-3.svg";

export const heroSectionImages = [HeroImage2, HeroImage3, HeroImage5];
